const creditSet ={
  path: '/creditManage/creditSet',
  component: resolve => require(['@/views/creditManage/creditSet'], resolve),
  name: 'creditSet',
  meta: {title: '信用类别设置',keepAlive: false},
};

const creditUser = {
  path: '/creditManage/creditUser',
  component: resolve => require(['@/views/creditManage/creditUser'], resolve),
  name: 'creditUser',
  meta: {title: '用户信用',keepAlive: false}
};

 const creditUserCert = {
   path: '/creditManage/creditUserCert',
   component: resolve => require(['@/views/creditManage/creditUserCert'], resolve),
   name: 'creditUserCert',
   meta: {title: '信用证书',keepAlive: false}
 };
 const auditUserCert = {
   path: '/creditManage/auditUserCert',
   component: resolve => require(['@/views/creditManage/auditUserCert'], resolve),
   name: 'auditUserCert',
   meta: {title: '待审证书',keepAlive: false}
 };
export default [creditSet,creditUser,creditUserCert,auditUserCert]



// WEBPACK FOOTER //
// ./src/router/modules/creditManage.js